export const WP_HOST = "https://pastanim.com";
export const WP_API = `${WP_HOST}/wp-json/wp/v2`;
export const GET_RECENT_POSTS_URL = `${WP_API}/posts?_fields=excerpt,title,link,date,slug,featured_media,categories,author,yoast_head`;
export const GET_POST = `${WP_API}/posts`;
export const GET_ALL_CATEGORIES = `${WP_API}/categories?_fields=id,name`;
export const NEWSLETTER_SUBSCRIBE_URL = `${WP_HOST}/index.php?na=s`;
export const MEDIA_URL = `${WP_API}/media`;
export const GET_USER = `${WP_API}/users?_fields=name,id`;